import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import { SnapshotAlarmSettingForm } from './types';
import { Control, Controller, FieldErrors } from 'react-hook-form';

interface Props {
  control: Control<SnapshotAlarmSettingForm>;
  handleSubmit: () => void;
  handleTestSnmp: () => void;
  hasChanges: boolean;
  errors: FieldErrors<SnapshotAlarmSettingForm>;
}

const SnmpSetup = ({
  control,
  handleSubmit,
  hasChanges,
  handleTestSnmp,
  errors,
}: Props) => {
  return (
    <>
      <Grid container style={{ paddingTop: '1.4rem', paddingRight: '1.4rem' }}>
        <Grid
          container
          item
          justifyContent='center'
          style={{ margin: 0, paddingRight: '1.1rem', paddingBottom: '1.1rem' }}
          spacing={2}
          xs={8}
          md={6}
          lg={5}
          xl={4}
          component={Paper}
        >
          <Controller
            name='snmp_server'
            control={control}
            defaultValue={''}
            render={({ field: { onChange, value } }) => (
              <Grid item xs={11}>
                <TextField
                  id='snmp_server'
                  label='Trap Receiver'
                  name='snmp_server'
                  value={value || ''}
                  onChange={onChange}
                  fullWidth
                />
              </Grid>
            )}
          />
          <Controller
            name='snmp_port'
            control={control}
            defaultValue={162}
            rules={{ min: 1 }}
            render={({ field: { onChange, value } }) => (
              <Grid item xs={11}>
                <TextField
                  id='snmp_port'
                  label='Port'
                  name='snmp_port'
                  type='number'
                  value={value || ''}
                  onChange={onChange}
                  fullWidth
                  inputProps={{ min: 1 }}
                  error={!!errors.snmp_port}
                />
              </Grid>
            )}
          />
          <Controller
            name='snmp_community'
            control={control}
            defaultValue={'public'}
            render={({ field: { onChange, value } }) => (
              <Grid item xs={11}>
                <TextField
                  id='snmp_community'
                  label='Community'
                  name='snmp_community'
                  value={value || ''}
                  onChange={onChange}
                  fullWidth
                />
              </Grid>
            )}
          />
          <Controller
            name='snmp_version'
            control={control}
            defaultValue={0}
            render={({ field: { onChange, value } }) => (
              <Grid item xs={11}>
                <FormControl sx={{ minWidth: 195 }} fullWidth>
                  <InputLabel id='snmp-version-label'>Version</InputLabel>
                  <Select
                    labelId='snmp-version-label'
                    id='snmp_version'
                    name='snmp_version'
                    label='Version'
                    value={value === null || value === undefined ? 0 : value}
                    onChange={onChange}
                  >
                    <MenuItem value={0}>SNMP v2c</MenuItem>
                    <MenuItem value={1}>SNMP v3</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
          />
          <Controller
            name='snmp_message'
            control={control}
            defaultValue={''}
            render={({ field: { onChange, value } }) => (
              <Grid item xs={11}>
                <TextField
                  id='snmp_message'
                  label='Test Message'
                  name='snmp_message'
                  value={value || ''}
                  onChange={onChange}
                  fullWidth
                />
              </Grid>
            )}
          />
          <Grid container item spacing={1} justifyContent='flex-end'>
            <Grid item xs={6}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleTestSnmp}
                fullWidth
              >
                Test
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSubmit}
                fullWidth
                disabled={!hasChanges}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} />
        </Grid>
      </Grid>
    </>
  );
};
export default SnmpSetup;
